import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { GroupRoles, IGroupMember } from '../Types';

const RESOURCE = 'group-member';

interface ICreateGroupMember extends Omit<IUri, 'resource'> {
  endUserId: string;
  groupId: string;
  token: string;
}

interface ICreateGroupMemberResponse extends IHttpResponse {
  body?: IGroupMember;
}

export default ({
  endUserId,
  groupId,
  token,
}: ICreateGroupMember): Promise<ICreateGroupMemberResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
  });

  const data = {
    role: GroupRoles.Member,
    _embedded: { group: { id: groupId }, 'end-user': { id: endUserId } },
  };

  return BaseService.Post({ url, token, data });
};
